module.exports = __webpack_public_path__ + "img/qrcode3.64dc1a4e.png";